import React, { createContext, useContext, useState } from 'react';
import type { Dispatch, ReactNode, SetStateAction } from 'react';

type A11yMode = string | null;

export const AccessibilityContext = createContext<{
  a11yMode?: A11yMode,
  setA11yMode?: Dispatch<SetStateAction<undefined>>,
}>({});

export const AccessibilityProvider = ({ children }: { children: ReactNode }) => {
  const [a11yMode, setA11yMode] = useState();

  return <AccessibilityContext.Provider value={{ a11yMode, setA11yMode }}>{children}</AccessibilityContext.Provider>;
};

export const useAccessibility = () => useContext(AccessibilityContext);
